import PropTypes from 'prop-types';
import {InferPropTypes} from '../util/type.utils';

/**
 * A section for content within an application with theme-able padding.
 * 
 * **Usage**
 * ```
 * ddk._SectionHeading(title="Overview", subtitle="A high level look at the last quarter.")
 * ddk._SectionHeading(title="Overview")
 * ```
 */
export function _Section({
    children,
}: InferPropTypes<typeof _Section.propTypes>) {
    return <section className="section">{children}</section>;
}

_Section.propTypes = {
    /**
     * Anything you would like to be rendered in the section.
     */
    children: PropTypes.node,
};
